import { createVfm } from "vue-final-modal";

export const vfm = createVfm()